/* VitaVerse — 把付款品牌徽章列放到頁尾與購物車
 * 標記模板來自 layout/theme.liquid 的 <template id="vv-pay-badges-tpl">
 * 商品頁的徽章列是由 pay_vitaxall block 自己渲染的，這支不碰它
 */
(function () {
  function tplHTML() {
    var t = document.getElementById('vv-pay-badges-tpl');
    return t ? t.innerHTML.trim() : '';
  }

  function makeRow() {
    var wrap = document.createElement('div');
    wrap.className = 'vv-pay-inject';
    wrap.setAttribute('data-vv-pay', '1');
    wrap.innerHTML = tplHTML();
    return wrap;
  }

  function injectAfter(refEl, hideEls) {
    if (!refEl) return false;
    // 已經有一列了就只確保原生的被藏起來
    var already = refEl.parentNode && refEl.parentNode.querySelector(':scope > [data-vv-pay]');
    if (!already) {
      var host = refEl.parentNode;
      if (!host) return false;
      // 掃一下同層有沒有（:scope 舊瀏覽器不支援時的保險）
      var sibs = host.children, has = false;
      for (var i = 0; i < sibs.length; i++) { if (sibs[i].getAttribute && sibs[i].getAttribute('data-vv-pay')) { has = true; break; } }
      if (!has) refEl.insertAdjacentElement('afterend', makeRow());
    }
    (hideEls || []).forEach(function (el) { if (el) el.style.display = 'none'; });
    return true;
  }

  function run() {
    if (!tplHTML()) return;

    // 頁尾：把整列放在 .additional-footer 之後，藏掉原生 ul.icon-payment
    var addFooter = document.querySelector('#section-footer .additional-footer, .section-footer .additional-footer');
    if (addFooter) {
      var footUl = (document.querySelector('#section-footer') || document).querySelectorAll('ul.icon-payment');
      injectAfter(addFooter, Array.prototype.slice.call(footUl));
    }

    // 購物車：放在結帳框裡原生付款圖示之後
    var cartUls = document.querySelectorAll('.form-checkout ul.icon-payment');
    Array.prototype.forEach.call(cartUls, function (ul) {
      injectAfter(ul, [ul]);
    });
  }

  var raf = 0;
  function schedule() {
    if (raf) return;
    raf = (window.requestAnimationFrame || window.setTimeout)(function () { raf = 0; run(); }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // 購物車數量變動 / 移除商品會用 AJAX 重繪結帳框 → 觀察 DOM 重新注入
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:updated', schedule);
})();
